import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
  Input,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { KeyboardService } from "app/services/keyboard.service";

@Component({
  selector: "app-keyboard",
  templateUrl: "./keyboard.component.html",
  styleUrls: ["./keyboard.component.scss"],
})
export class KeyboardComponent implements OnInit {
  isPassword: boolean = false;
  value: string = "";
  shiftKey: string = "SHIFT";
  altKey: string = "Alt Gr";
  capsKey: string = "Caps";
  spaceKey: string = " ";
  character: string = "";
  shift: boolean = false;
  alt: boolean = false;
  caps: boolean = false;
  inputId: string = "";
  prevRoute: string = "";
  enterKey: string = "ENTER";
  capsOn: boolean = false;
  @Input("value") input: string;
  @ViewChild("keyValue") inputValue: ElementRef;

  public normalkeys: Array<string> = [
    "º",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "0",
    "'",
    "¡",
    "&#x2190;",
    "TAB->",
    "q",
    "w",
    "e",
    "r",
    "t",
    "y",
    "u",
    "i",
    "o",
    "p",
    "`",
    "+",
    "Caps",
    "a",
    "s",
    "d",
    "f",
    "g",
    "h",
    "j",
    "k",
    "l",
    "ñ",
    "´",
    "ç",
    "ENTER",
    "SHIFT",
    "<",
    "z",
    "x",
    "c",
    "v",
    "b",
    "n",
    "m",
    ",",
    ".",
    "-",
    "Alt Gr",
    " ",
  ];
  public specialKeys: Array<string> = [
    "&#x2190;",
    "SHIFT",
    "Caps",
    "ENTER",
    "SHIFT",
    "SHIFT",
    " ",
  ];
  public extraSpecialKeys: Array<string> = ["ENTER", "Caps", "Alt Gr", "TAB->"];
  public keys: Array<string> = this.normalkeys;
  public shiftKeys: Array<string> = [
    "ª",
    "!",
    '"',
    "·",
    "$",
    "%",
    "&",
    "/",
    "(",
    ")",
    "=",
    "?",
    "¿",
    "&#x2190;",
    "TAB->",
    "Q",
    "W",
    "E",
    "R",
    "T",
    "Y",
    "U",
    "I",
    "O",
    "P",
    "^",
    "*",
    "Caps",
    "A",
    "S",
    "D",
    "F",
    "G",
    "H",
    "J",
    "K",
    "L",
    "Ñ",
    "¨",
    "Ç",
    "ENTER",
    "SHIFT",
    ">",
    "Z",
    "X",
    "C",
    "V",
    "B",
    "N",
    "M",
    ";",
    ":",
    "_",
    "Alt Gr",
    " ",
  ];
  public altKeys: Array<string> = [
    "\\",
    "|",
    "@",
    "#",
    "~",
    "€",
    "¬",
    "",
    "",
    "",
    "",
    "",
    "",
    "&#x2190;",
    "TAB->",
    "",
    "",
    "€",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "[",
    "]",
    "Caps",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "{",
    "}",
    "ENTER",
    "SHIFT",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "Alt Gr",
    " ",
  ];

  constructor(
    public cdkRef: ChangeDetectorRef,
    public keyboardService: KeyboardService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe({
      next: (value) => {
        if (value["inputId"] != null) {
          this.inputId = value["inputId"];
        }
        if (value["value"] != null) {
          this.value = value["value"];
        }
      },
    });
    this.prevRoute = this.keyboardService.getRoute() ?? '';
    if (this.input != null && this.input != undefined) this.value = this.input;

    setTimeout(() => {
      this.focus();
    }, 100);
  }

  onKeyClick(event: string) {
    this.focus();
    const key = this.getCaracter(event);

    if (key == "CapsLock") {
      if (this.alt || this.shift) this.restoreOriginalKeys();
      this.caps = !this.caps;
      if (this.caps) {
        this.toUpperCase();
      } else {
        this.toLowerCase();
      }
    } else if (key == "ShiftLeft") {
      if (this.caps || this.alt) this.restoreOriginalKeys();
      this.shift = !this.shift;
      if (this.shift) this.keys = this.shiftKeys;
      else this.restoreOriginalKeys();
      this.cdkRef.detectChanges();
    } else if (key == "Alt") {
      if (this.shift || this.caps) this.restoreOriginalKeys();
      this.alt = !this.alt;
      if (this.alt) this.keys = this.altKeys;
      else this.restoreOriginalKeys();
    } else if (key == "Tab") {
      this.sendKey(key);
    } else if (key == "Backspace") {
      this.sendKey(key);
    } else if (key == "Enter") {
      this.onClose();
    } else {
      this.sendKey(key);
      if (!this.caps) this.restoreOriginalKeys();
    }
  }

  sendKey(key: string) {
    if (key == "Backspace") {
      this.value =
        this.value.length > 1
          ? this.value.substring(0, this.value.length - 1)
          : "";
    } else if (key == "Tab") {
      this.value = this.value + "\t";
    } else {
      this.value = this.value + key;
    }
  }

  getCaracter(c: string): string {
    let key = "";
    switch (c) {
      case "&#x2190;":
        key = "Backspace";
        break;
      case "TAB->":
        key = "Tab";
        break;
      case "Caps":
        key = "CapsLock";
        break;
      case "ENTER":
        key = "Enter";
        break;
      case "SHIFT":
        key = "ShiftLeft";
        break;
      case "Alt Gr":
        key = "Alt";
        break;
      default:
        key = c;
        break;
    }
    return key;
  }

  toLowerCase() {
    for (let i = 0; i < this.keys.length; i++) {
      if (!this.keys[i].startsWith("&") && this.keys[i].length < 2) {
        this.keys[i] = this.keys[i].toLowerCase();
      }
    }
  }

  toUpperCase() {
    for (let i = 0; i < this.keys.length; i++) {
      if (!this.keys[i].startsWith("&") && this.keys[i].length < 2) {
        this.keys[i] = this.keys[i].toUpperCase();
      }
    }
  }

  restoreOriginalKeys() {
    this.caps = false;
    this.shift = false;
    this.alt = false;
    this.keys = this.normalkeys;
    this.toLowerCase();
  }

  focus() {
    this.inputValue.nativeElement.focus();
  }

  onClose() {
    this.keyboardService.setKeyboardValues(
      this.inputId,
      this.value,
      this.prevRoute
    );
    this.router.navigateByUrl(this.prevRoute);
  }
}
